export const PWA_ADD_TO_HOME_SCREEN = 'PWA - Add to home screen';
